export default __webpack_public_path__ + "favicon-114-f8fe1128d03936ea9334e0fd9473aa7c.bundle.png";